import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { NgForm } from '@angular/forms';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';


@Component({
  selector: 'app-usuario-editar',
  templateUrl: './usuario-editar.component.html',
  styleUrls: ['./usuario-editar.component.scss']
})
export class UsuarioEditarComponent implements OnInit {

  progressoRequisicao: boolean = false;
  loadingUsuario: boolean = false;
  id?: number;
  messages: Message[] = [{ severity: 'success', summary: 'Sucesso', detail: 'Cliente salvo' }];
  messagemVisivel: boolean = false;
  usuario?: Usuario;
  tipos: string[] = [
    'EMPRESA',
    'FRANQUIA'
  ];

  constructor(private usuarioService: UsuarioService,
    private erroService: ErroService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.loadingUsuario = true;
    this.carregarIdUsuario();
    this.buscarUsuarioPorId();
  }

  buscarUsuarioPorId() {
    this.usuarioService.buscarPorId(this.id).subscribe({
      next: (data: Usuario) => {
        this.loadingUsuario = false;
        this.usuario = data;
      },
      error: (err: any) => {
        this.loadingUsuario = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  atualizar(form: NgForm) {
    this.progressoRequisicao = true;
    const usuario: Usuario = form.value;
    if (!usuario.apelido) {
      usuario.apelido = this.formatarApelido(usuario.nome);
    }
    this.usuarioService.atualizar(this.id, usuario).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.rolarTela();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    });

  }

  formatarApelido(nome?: string): string {
    return nome !== undefined ? nome.split(' ')[0] : '';
  }

  carregarIdUsuario() {
    const idParam = this._activatedRoute.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }


  navigateToFirstChild() {
    this._router.navigate(["/auth/login"], { relativeTo: this._activatedRoute })
  }

  editarIndicadorCliente(id: number) {
    this._router.navigate(["/apps/indicador-cliente/editar/" + id], { relativeTo: this._activatedRoute })
  }


  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
